import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './AdminMaintenanceLayout.styles';
// import {
//   AdminHeader,
//   AdminFooter,
//   AdminSideSlides,
//   AdminMaintenanceMain,
//   KioskIdelScreen
// } from '..';

import AdminHeader from './../AdminLayout/AdminHeader';
import AdminFooter from './../AdminLayout/AdminFooter';
import AdminSideSlides from './../AdminLayout/AdminSideSlides';
import AdminMaintenanceMain from './AdminMaintenanceMain';
import KioskIdelScreen from './../../KioskLayout/KioskIdelScreen';

export class AdminMaintenanceLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };
  state = {
    stepTitle: '',
    pageTitle: 'What are you here to do?',
    height: 300
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.container)}>
        <AdminHeader myLogoheight={this.state.height} />
        <AdminSideSlides
          pageTitle={this.state.pageTitle}
          customTop={this.state.customTop}
          customHeight={120}
        />
        <AdminMaintenanceMain />
        <AdminFooter customFooterBottom="0%" />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AdminMaintenanceLayout);
